/* eslint-disable react/destructuring-assignment */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { LoadingOverlay } from '@airtm/airtm-ui';
import JwtManager from 'lib/JwtManager';
import { LOCAL_STORAGE } from '@constants';
import { CombinedGraphQLErrors } from '@apollo/client/errors';
import CompleteProfileForm from './CompleteProfileForm/CompleteProfileForm';
import CompleteProfileContainer from './CompleteProfileContainer';

class CompleteProfile extends Component {
  static propTypes = {
    toast: PropTypes.func.isRequired,
    signUpPartialConfirm: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
    user: PropTypes.shape({
      email: PropTypes.string,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      country: PropTypes.string,
      id: PropTypes.string,
    }).isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      serverErrors: {},
      submitting: false,
    };
  }

  componentDidMount() {
    const { user } = this.props;
    localStorage.removeItem(`${LOCAL_STORAGE.REQUEST_VERIFICATION_EMAIL}-${user.id}`);
  }

  onSubmit = async (userData) => {
    const { toast, signUpPartialConfirm } = this.props;

    try {
      this.setState({
        serverErrors: {},
        submitting: true,
      });

      const response = await signUpPartialConfirm({ user: userData });

      const { jwt } = response.data.signUpPartialConfirm;

      if (window.AndroidInterface) {
        window.AndroidInterface.refreshToken(
          JSON.stringify({
            jwt,
          }),
        );
      }

      JwtManager.jwt = jwt.jwt;

      localStorage.setItem(LOCAL_STORAGE.SHOW_DOCUMENTATION_SCREEN, 'true');
      localStorage.removeItem(LOCAL_STORAGE.SKIP_SELECT_PROVIDER);
      localStorage.removeItem(LOCAL_STORAGE.SELECTED_CUSTODIAL_PROVIDER);
    } catch (error) {
      try {
        if (!CombinedGraphQLErrors.is(error)) {
          throw error;
        }

        const [graphQLError] = error.errors;
        const message = graphQLError?.extensions?.response?.body?.message;
        const messages = graphQLError?.extensions?.response?.body?.messages;
        const status = graphQLError?.extensions?.response?.status;

        if (status === 422) {
          if (message === 'User already registered') {
            window.location.reload();
          } else if (message === 'Email not verified yet') {
            // eslint-disable-next-line no-console
            console.error('Email not verified yet');
          } else {
            this.setState({
              serverErrors: messages,
            });
          }
        }

        if (status === 500) {
          if (message?.includes('PHONE_ALREADY_REGISTERED')) {
            const { t } = this.props;
            toast({
              autoClose: false,
              message: t('ERRORS:PHONE_ALREADY_REGISTERED'),
              title: t('STATIC:SOMETHING_WENT_WRONG'),
              type: 'error',
            });
            return;
          }
        }
        throw new Error(message);
      } catch {
        const { t } = this.props;
        toast({
          autoClose: false,
          message: t('ERRORS:UNEXPECTED_ERROR'),
          title: t('STATIC:SOMETHING_WENT_WRONG'),
          type: 'error',
        });
      } finally {
        this.setState({
          submitting: false,
        });
      }
    }
  };

  render() {
    const { t, user } = this.props;

    return (
      <>
        <section className="section py-8 pt-sm-6 pt-md-5">
          <h2>{t('SIGNUP:CONFIRMATION_COMPLETE_PROFILE')}</h2>

          <CompleteProfileForm
            id="complete-profile-form"
            user={user}
            onSubmit={this.onSubmit}
            serverErrors={this.state.serverErrors}
            submitting={this.state.submitting}
          />
        </section>

        {this.state.submitting && <LoadingOverlay />}
      </>
    );
  }
}

export default CompleteProfileContainer(CompleteProfile);
